var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"foot-bar",staticStyle:{"bottom":"0","z-index":"999"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns has-text-centered"},[_c('div',{staticClass:"column"},[_c('p',{staticStyle:{"margin-bottom":"2rem"}},[_vm._v(" © 2024 財團法人臺灣生活美學基金會. All Rights Reserved. ")])])])])])
}]

export { render, staticRenderFns }